import { ComponentPropsWithoutRef, FC } from "react";

type TextIconProps = {} & ComponentPropsWithoutRef<"svg">;

const TextIcon: FC<TextIconProps> = ({ ...rest }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth={0.5}
      {...rest}
      className={`${rest.className} fill-current stroke-current`}
    >
      <path d="M24 6H17V26H22V28H10V26H15V6H8V10H6V4H26V10H24V6Z" />
    </svg>
  );
};

export default TextIcon;
